import React, { useEffect, useState } from 'react';
import './header.css'; // Import the CSS file for styling
import { Link, useLocation } from 'react-router';
const Header = () => {
  const location = useLocation();
  const [home,setHome] = useState(true)
  const fsdf = useEffect(()=>{
    if (location.pathname=="/"){
      setHome(true)
    } else {
      // setHome(false)
    }
  },[location.pathname])
  return (
    <header className="site-header">
      <h1 className={home&&'bouncing-text'}><Link to="/"><Link to="/">{[..."JoaquimBocresion"].map((l,i)=>(<span className={home&&"letter"} style={{animationDelay:home&&`${i+3*Math.random()}s`}}>{l}</span>))}</Link></Link></h1>
      <nav className="nav-bar">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">CV</Link></li>
          <li><Link to="/blog">Blog</Link></li>
          <li><Link to="/notes">Notes</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
